import { HTTP_METHODS } from '@/utils/constants/httpMethods'

export const ONLINE_ORDER_CONFIG = {
  ONLINE_ORDER: (queryParams) => ({
    endPoint: 'orders?orderType=ONLINE&' + queryParams,
    baseUrlKey: 'omsApiUrl', // Dynamically use OMS_API_URL
    method: HTTP_METHODS.POST,
  }),
  ONLINE_ORDER_CSV_DOWNLOAD: (queryParams) => ({
    endPoint: 'orders/download?' + queryParams,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'omsApiUrl', // Dynamically use OMS_API_URL
  }),
}